import AdsNewsletterModal from './AdsNewsletterModal.vue';

export function openAdsNewsletterModal() {
  if (!this) {
    throw new Error('openAdsNewsletterModal must be called on a Vue instance');
  }

  return this.$modal.open({
    title: this.$t('SUBSCRIBE_TO_NEWSLETTER'),
    component: AdsNewsletterModal,
    width: '20%',
  });
}
